import { LOGIN_ROUTE_PATH } from '@/router/constants';

const TOKEN_KEY = 'openatom-api-token';
const AUTH_CODE = [100101, 100102, 101001];

const base = `${window.location.protocol}//${window.location.host}`;

export const isLogin = () => {
  if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
    return true;
  }
  else {
    return !!localStorage.getItem(TOKEN_KEY);
  }
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const gotoLogin = async (from = '/') => {
  const redirect = `${base}${LOGIN_ROUTE_PATH}?from=${encodeURIComponent(from)}`;
  const loginPath = `${import.meta.env.VITE_ATOMGIT_URL}/callback?transfer_redirect=${encodeURIComponent(redirect)}`;

  window.location.replace(loginPath);
};

export const isAuthCode = (code: number) => AUTH_CODE.includes(code);
